/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * Describes type of data columns to use for the data legend.
 */
export var DataLegendSeriesValueType = /*@__PURE__*/ (function (DataLegendSeriesValueType) {
    /**
     * Specifies the Value data column for the category series and radial series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Value"] = 0] = "Value";
    /**
     * Specifies the Low data column for the financial price series and range series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Low"] = 1] = "Low";
    /**
     * Specifies the High data column for the financial price series and range series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["High"] = 2] = "High";
    /**
     * Specifies the Open data column for the financial price series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Open"] = 3] = "Open";
    /**
     * Specifies the Close data column for the financial price series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Close"] = 4] = "Close";
    /**
     * Specifies the typical price column for the financial price series: (high + low + close) / 3
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["TypicalPrice"] = 5] = "TypicalPrice";
    /**
     * Specifies the average column between high/low for the range series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Average"] = 6] = "Average";
    /**
     * Specifies the range column between high/low for the range series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Range"] = 7] = "Range";
    /**
     * Specifies the Volume data column for the financial price series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Volume"] = 8] = "Volume";
    /**
     * Specifies the Change data column for the financial price series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Change"] = 9] = "Change";
    /**
     * Specifies the Angle data column for the polar series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Angle"] = 10] = "Angle";
    /**
     * Specifies the Radius data column for the polar series, radial series, and bubble series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Radius"] = 11] = "Radius";
    /**
     * Specifies the Fill data column for the bubble series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Fill"] = 12] = "Fill";
    /**
     * Specifies the X data column for the bubble series and scatter series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["XValue"] = 13] = "XValue";
    /**
     * Specifies the Y data column for the bubble series and scatter series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["YValue"] = 14] = "YValue";
    /**
     * Specifies the summary data columns for all series
     */
    DataLegendSeriesValueType[DataLegendSeriesValueType["Summary"] = 15] = "Summary";
    return DataLegendSeriesValueType;
})({});
/**
 * @hidden
 */
export var DataLegendSeriesValueType_$type = /*@__PURE__*/ markEnum('DataLegendSeriesValueType', 'Value,0|Low,1|High,2|Open,3|Close,4|TypicalPrice,5|Average,6|Range,7|Volume,8|Change,9|Angle,10|Radius,11|Fill,12|XValue,13|YValue,14|Summary,15');
